const GA4_ID = 'G-PK73KNBBXG';

/**
 * Safe wrapper — only fires if gtag is loaded (user accepted cookies)
 */
function gtag() {
  if (typeof window.gtag === 'function') {
    window.gtag.apply(null, arguments);
  }
}

/** Send a virtual page_view for SPA route changes */
export function trackPageView(path, title) {
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.origin + path,
    send_to: GA4_ID,
  });
}

/** Track CTA button clicks */
export function trackCTAClick(ctaName, location) {
  gtag('event', 'cta_click', {
    event_category: 'engagement',
    event_label: ctaName,
    cta_location: location,
  });
}

/** Track contact form submission */
export function trackFormSubmit(success) {
  gtag('event', success ? 'generate_lead' : 'form_error', {
    event_category: 'conversion',
    event_label: 'contact_form',
    value: success ? 1 : 0,
  });
}

/** Track outbound link clicks */
export function trackOutboundClick(url) {
  gtag('event', 'click', {
    event_category: 'outbound',
    event_label: url,
    transport_type: 'beacon',
  });
}

/** Track which service section a user views */
export function trackSectionView(sectionName) {
  gtag('event', 'view_section', {
    event_category: 'engagement',
    event_label: sectionName,
  });
}

/** Track scroll depth milestones */
export function trackScrollDepth(percent) {
  gtag('event', 'scroll_depth', {
    event_category: 'engagement',
    event_label: `${percent}%`,
    value: percent,
  });
}
